import { NETWORK_DETAILS_BY_ID } from './networks';

const getExplorerForChain = (chainId: number | string) => {
	return NETWORK_DETAILS_BY_ID[chainId]?.explorers[0].url;
};

export { getExplorerForChain };
